import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toast"]

  connect() {
    this.timeouts = this.toastTargets.map((toast) =>
      window.setTimeout(() => this.hide(toast), 6000),
    )
  }

  disconnect() {
    this.timeouts?.forEach((timeout) => window.clearTimeout(timeout))
  }

  dismiss(event) {
    this.hide(event.currentTarget.closest("[data-flash-target='toast']"))
  }

  hide(toast) {
    if (!toast || toast.dataset.dismissing === "true") return

    toast.dataset.dismissing = "true"
    toast.classList.add("flash-toast--dismissing")

    window.setTimeout(() => toast.remove(), 180)
  }
}
